export const OTP_SERVICE_MESSAGES = [
  {
    label: 'Whatsapp',
    value: 'whatsapp',
    message: 'Ingresa el código de 4 dígitos que recibirás a través de <strong>WhatsApp</strong> y confirma tu firma digital presionando el botón <strong>"Firmar"</strong>'
  },
  {
    label: 'Llamada',
    value: 'llamada',
    message: 'Ingresa el código de 4 dígitos que recibirás a través de una <strong>llamada telefónica</strong> y confirma tu firma digital presionando el botón <strong>"Firmar"</strong>'
  },
  {
    label: 'SMS',
    value: 'sms',
    message: 'Ingresa el código de 4 dígitos que recibirás a través de un <strong>SMS</strong> y confirma tu firma digital presionando el botón <strong>"Firmar"</strong>'
  }
];